module.exports = __webpack_public_path__ + "static/img/banner-newone.f168d0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/banner-newone.png
// module id = XVn8
// module chunks = 44